/* eslint-disable no-undef */
import $api from '@/http/api'
import $utils from '@/utils/utils'

class WxHandle {
	configParams = {
		debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
		appId: '', // 必填，公众号的唯一标识
		timestamp: '', // 必填，生成签名的时间戳
		nonceStr: '', // 必填，生成签名的随机串
		signature: '', // 必填，签名
		jsApiList: ['chooseImage', 'uploadImage', 'chooseWXPay'], // 必填，需要使用的 JS 接口列表
		openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
	}

	getDomainUrl() {
		const href = window.location.href
		return href.split('#')[0]
	}
	/**
	 * 设置 config 参数
	 * @param { object } params
	 */
	async setConfigParams(params = {}) {
		params.url = this.getDomainUrl()
		const res = await $api.account.wxGetConfig(params)
		if (!res.code) {
			Object.keys(this.configParams).forEach(key => {
				if (!$utils.isArray(res.data[key])) {
					this.configParams[key] = res.data[key] || this.configParams[key]
				}
			})
		}
		return this
	}
	/**
	 * 调用鉴权
	 * @param { function | null } readyCallback
	 * @param { function | null } errorCallback
	 */
	config(readyCallback = null, errorCallback = null) {
		const _this = this
		window.wx.config(this.configParams)
		window.wx.ready(() => {
			readyCallback && readyCallback(_this)
		})
		window.wx.error(err => {
			errorCallback && errorCallback(err)
		})
	}
	/**
	 * 调取微信支付功能
	 * @param { function | null } successCallback
	 */
	async pay(params = {}, successCallback = null) {
		const res = await $api.pay.wxPayOrder(params)
		if (!res.code) {
			window.wx.chooseWXPay({
				timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
				nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
				package: res.data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
				signType: res.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
				paySign: res.data.paySign, // 支付签名
				success(res) {
					// 支付成功后的回调函数
					successCallback && successCallback(res)
				}
			})
		}
	}
	/**
	 * 调取微信支付功能-咨询订单
	 * @param { function | null } successCallback
	 */
	async consultPay(params = {}, successCallback = null, cancelCallback = null, failCallback = null) {
		window.wx.chooseWXPay({
			timestamp: params.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
			nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
			package: params.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
			signType: params.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
			paySign: params.paySign, // 支付签名
			success(res) {
				// 支付成功后的回调函数
				successCallback && successCallback(res)
			},
			cancel: function (res) {
				cancelCallback && cancelCallback(res)
			},
			// 支付失败回调函数
			fail: function (res) {
				failCallback && failCallback(res)
			}
		})
	}
	windowClose() {
		console.log('---s')
		setTimeout(function () {
			if (WeixinJSBridge) {
				//这个可以关闭安卓系统的手机
				document.addEventListener(
					'WeixinJSBridgeReady',
					function () {
						WeixinJSBridge.call('closeWindow')
					},
					false
				)
				//这个可以关闭ios系统的手机
				WeixinJSBridge.call('closeWindow')
			}
		}, 300)
	}
}

export default new WxHandle()
